import React from "react";
import { X, ExternalLink } from "lucide-react";
import CardFace from "./CardFace";
import { rarityMeta, RARITY_FULL } from "../lib/helpers";

export default function CardDetailModal({ card, imagesEnabled, onClose }) {
  if (!card) return null;
  const meta = rarityMeta(card.rarity);
  const rows = [
    ["Numero", card.number],
    ["Rarità", `${RARITY_FULL[card.rarity] || "—"} (${card.rarity})`],
    ["Rarità stampa", card.source_rarity],
    ["Tipo", card.card_type],
    ["Colori", (card.colors || []).join(", ") || "—"],
    ["Categorie", (card.types || []).join(", ") || "—"],
    ["Costo / Vita", card.cost_or_life ?? "—"],
    ["Potenza", card.power ?? "—"],
    ["Counter", card.counter ?? "—"],
    ["Attributo", card.attribute ?? "—"],
    ["Block", card.block ?? "—"],
    ["Posseduta", `×${card.quantity || 0}`],
  ];

  return (
    <div className="fixed inset-0 z-50 bg-[#0b1324]/80 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={onClose} data-testid="card-detail-modal">
      <div className="w-full max-w-md bg-[#eef8ff] rounded-t-3xl sm:rounded-3xl max-h-[92vh] overflow-y-auto no-scrollbar" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-[#eef8ff]/95 backdrop-blur px-4 py-3 flex items-center justify-between border-b border-sky-100">
          <div className="font-display font-bold truncate pr-2">{card.name}</div>
          <button onClick={onClose} data-testid="detail-close-btn" className="pill-soft w-9 h-9 flex items-center justify-center shrink-0">
            <X size={18} />
          </button>
        </div>
        <div className="p-4">
          <div className="max-w-[220px] mx-auto">
            <CardFace card={card} imagesEnabled={imagesEnabled} />
          </div>
          <div className="flex items-center justify-center gap-2 mt-3">
            <span className={`chip ${meta.cls}`}>{meta.label}</span>
            <span className={`chip ${card.is_base === false ? "bg-purple-100 text-purple-700 border-purple-200" : "bg-sky-100 text-sky-700 border-sky-200"}`}>
              {card.is_base === false ? "Variante" : "Base"}
            </span>
          </div>

          <div className="luma-card !rounded-2xl mt-4 divide-y divide-sky-50">
            {rows.map(([k, v]) => (
              <div key={k} className="flex items-center justify-between px-3.5 py-2 text-sm">
                <span className="luma-muted font-semibold">{k}</span>
                <span className="font-bold text-right ml-3">{v}</span>
              </div>
            ))}
          </div>

          {card.source_url && (
            <a href={card.source_url} target="_blank" rel="noopener noreferrer nofollow" className="mt-4 pill-soft w-full py-2.5 flex items-center justify-center gap-2 text-sm">
              <ExternalLink size={15} /> Scheda sorgente
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
